import * as functions from '../constants/Functions'
import * as generalActions from './generalActions'
import * as layoutActions from './layoutActions'
import * as loginActions from './loginActions'
import * as receiptFunction from '../functions/ReceiptFunctions'
import * as receiptAction from './receiptActions'
import * as layoutAction from './layoutActions'
import * as modalAction from '../modal/actions/modalActions'
import * as invoiceAction from './invoiceActions'
import * as types from '../constants/Types'
import * as resource from '../constants/Resources'
import * as dataActions from './dataActions'
import { hasRight } from '../actions/rightsActions'
import * as right from '../constants/Rights'
import { hashHistory } from 'react-router';
import { getObjectGroupList, setCurrentObjectGroup, setMessageBarText } from '../objectmanagement/actions/objectManagementActions'
import $ from 'jquery'

export function processFunction(functionCode, param) {
	return (dispatch, getState) => {
		if (getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox
			&& getState().generalState.licenses.blackboxReceiptId > 0) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.PRINT_MISSING_RECEIPT))));
			return;
		}

		dispatch(generalActions.setKeyFunctionExecuted(functionCode));
		switch (functionCode) {
			case functions.Configuration:
				dispatch(processConfiguration());
				break;
			case functions.ObjectManagementOpen:
				dispatch(processObjectManagementOpen());
				break;
			case functions.ObjectManagementClose:
				dispatch(processObjectManagementClose());
				break;
			case functions.PrintNota:
				dispatch(processPrintNota(param));
				break;
			case functions.ObjectManagementSplit:
				dispatch(processSplitReceipt());
				break;
			case functions.PartialPaymentArticle:
				dispatch(processPartialPaymentArticle());
				break;
			case functions.PartialPaymentAmount:
				dispatch(processPartialPaymentAmount());
				break;
			case functions.ObjectManagementSetItemName:
				dispatch(processObjectManagementSetItemName());
				break;
			case functions.Subtotal:
				dispatch(processSubtotal());
				break;
			case functions.WorkIn:
				dispatch(receiptAction.workIn());
				break;
			case functions.WorkOut:
				dispatch(receiptAction.workOut());
				break;
			case functions.DiscountAmount:
				dispatch(processDiscount(true, param));
				break;
			case functions.DiscountPercentage:
				dispatch(processDiscount(false, param));
				break;
			case functions.DiscountMenu:
				dispatch(processDiscountMenu());
				break;
			case functions.PriceList:
				dispatch(processPriceList(param));
				break;
			case functions.ObjectManagementTransfer:
				dispatch(processObjectTransfer());
				break;
			case functions.CustomerList:
				dispatch(processCustomerBase(param));
				break;
			case functions.ConfigurationList:
				dispatch(processConfigurationList(param));
				break;
			case functions.ManagerLogin:
				dispatch(processManagerLogin(param));
				break;
			case functions.ReprintReceipt:
				dispatch(reprintReceipt())
				break;
			case functions.ShowOrders:
				dispatch(processShowOrders(param));
				break;
			case functions.FastPayment:
				dispatch(processFastPayment(param));
				break;
			case functions.ResetCustomer:
				dispatch(receiptAction.resetCustomer());
				break;
			case functions.OverruleAge:
				dispatch(receiptAction.overruleAge());
				break;
			case functions.ArticleList:
				dispatch(processArticleBase(param));
				break;
			case functions.ShowKeyLayoutGroup:
				dispatch(processKeyLayoutGroup(param));
				break;
			case functions.CancelReceipt:
				dispatch(receiptAction.emptyReceipt(false));
				break;
			case functions.ObjectManagementProcess:
				dispatch(processObjectManagementProcess());
				break;
			case functions.Invoice:
				dispatch(processSetInvoice());
				break;
			case functions.PrintInvoice:
				dispatch(processPrintInvoice());
				break;
			case functions.SetInvoiceReference:
				dispatch(processSetInvoiceReference());
				break;
			case functions.CollectReservation:
				dispatch(processReservation(param));
				break;
			case functions.AddBalanceToTicket:
				dispatch(addBalanceToTicket(param));
				break;
			case functions.CashIn:
				dispatch(processCashIn());
				break;
			case functions.CashOut:
				dispatch(processCashOut());
				break;
			case functions.Logout:
				dispatch(logOutEmployee());
				break;
			case functions.ParkOrder:
				dispatch(processParkOrder(param));
				break;
			case functions.CustomerInfo:
				dispatch(processCustomer());
				break;
			case functions.TicketInfo:
				dispatch(processTicketBase());
				break;
			case functions.ResetFiscalPrinter:
				dispatch(resetFiscalPrinter());
				break;
			case functions.PrintXReport:
				dispatch(printXReport());
				break;
			case functions.PrintZReport:
				dispatch(printZReport());
				break;
			case functions.SelectPager:
				dispatch(processSelectPager(param));
				break;
			default:
				break;
		}
	}
}

export function printXReport() {
	return (dispatch, getState) => {
				dispatch(receiptAction.generateXReport(false, false));
	}
}

export function printZReport() {
	return (dispatch, getState) => {
				dispatch(receiptAction.generateZReport());
	}
}

export function logOutEmployee() {
	return (dispatch, getState) => {
		var state = getState();
		var receiptNumber = state.receiptState.receipt.receiptnumber;
		if (receiptNumber) {
			if(state.receiptState.receipt.objectitemid || (state.objectManagementState.selectedobjectitem && state.objectManagementState.selectedobjectitem.id))
			{
				dispatch(receiptAction.closeReceipt(false, false));
			}
			else
			{
				dispatch(receiptAction.cancelReceipt());
			}
		}

		if (getState().loginState.logOutPossible) {
			dispatch(loginActions.logoutUser());
		}
	}
}

export function continueFunction() {
	return (dispatch, getState) => {
		const functioncode = getState().generalState.keyfunctionexecuted;
		switch (functioncode) {
			case functions.ObjectManagementOpen:
				dispatch(continueObjectManagementOpen());
				break;
			case functions.ObjectManagementSplit:
				dispatch(continueSplitReceipt());
				break;
			case functions.ObjectManagementTransfer:
				dispatch(continueObjectManagementTransfer());
				break;
			default:
				return;
		}
	}
}

function processCustomerBase(param) {
	return dispatch => {
		dispatch(receiptAction.showCustomerBase(param));
	}
}

function processCustomer() {
	return dispatch => {
		dispatch(receiptAction.showCustomer());
	}
}

function processTicketBase() {
	return dispatch => {
		dispatch(receiptAction.showTicketBase());
	}
}

function processArticleBase(param) {
	return dispatch => {
		dispatch(receiptAction.showArticleBase(param));
	}
}

function processConfigurationList(param) {
	return dispatch => {
		dispatch(receiptAction.showConfigurationList(param));
	}
}

function processConfiguration() {
	return (dispatch, getState) => {
		const line = receiptFunction.getSelectedLine(getState);
		if ((line === null) ||
			(line !== null && line.configuration.length === 0) ||
			(line !== null && line.linetype !== types.ARTICLE_LINE)) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_VALID_RECEIPTLINE_SELECTED))));
			return;
		}

		const article = dispatch(dataActions.getArticle(parseInt(line.itemid, 10)));
		if (article !== null) {
			dispatch(generalActions.setConfigurationModal(article, line.configuration, line.id));
		}
	}
}

export function processObjectManagementOpen() {
	return (dispatch, getState) => {
		const receiptNumber = getState().receiptState.receipt.receiptnumber
		if (receiptNumber >= 0 && receiptNumber != null) {
			const message = dispatch(dataActions.getTranslation(resource.RECEIPT_IS_OPEN));
			dispatch(generalActions.setMessageModal(true, message));
			return;
		}
		const posid = getState().generalState.posId;
		dispatch(generalActions.loadingStart());
		dispatch(getObjectGroupList(posid)).then(() => {
			const objectGroups = getState().objectManagementState.objectgroups;
			if (objectGroups.length > 0) {
				dispatch(setCurrentObjectGroup(objectGroups[0].ObjectGroupId));
			}
			dispatch(setMessageBarText(dispatch(dataActions.getTranslation(resource.CHOOSE_OBJECT))));
			dispatch(generalActions.loadingEnd());

			hashHistory.push('/objectmanagement');
		});
	}
}

export function continueObjectManagementOpen(objectitem) {
	return async (dispatch, getState) => {
		let selectedobjectitemid = 0;
		let selectedobjectitemreceiptnumber = 0;
		const objectItems = [];

		if (objectitem) {
			if (objectitem.Locked && !dispatch(dataActions.getLoggedInId(objectitem.LockedByUser))) {
				dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.OBJECT_OPEN_BY_CASHREGISTER)).format(objectitem.ItemNumber)));
				return;
			}
			selectedobjectitemid = objectitem.ObjectItemId;
			selectedobjectitemreceiptnumber = objectitem.ReceiptNumber;
		}
		else {
			const selectedobjectitem = getState().objectManagementState.selectedobjectitem;

			selectedobjectitemid = selectedobjectitem.id;
			selectedobjectitemreceiptnumber = selectedobjectitem.receiptnumber;

			if (selectedobjectitemreceiptnumber <= 0) {
				const selectedObject = dispatch(dataActions.getObjectItem(selectedobjectitemid));
				//Check if there are more objects on this coordinates
				const selectedGroup = getState().objectManagementState.selectedobjectgroup;
				for (let i = 0; i < getState().objectManagementState.objectgroups.length; i++) {
					const group = getState().objectManagementState.objectgroups[i];
					if (group.ObjectGroupId === selectedGroup) {
						for (let j = 0; j < group.ObjectItems.length; j++) {
							const item = group.ObjectItems[j];

							const startX = item.LocationX;
							const endX = item.LocationX + (item.Width - 1);

							const startY = item.LocationY;
							const endY = item.LocationY + (item.Height - 1);

							if (selectedObject.LocationX >= startX && selectedObject.LocationX <= endX
								&& selectedObject.LocationY >= startY && selectedObject.LocationY <= endY) {
								objectItems.push(item);
							}
						}
					}
				}


			}
		}

		const receipt = getState().receiptState.receipt;
		const posid = getState().generalState.posId;
		if (selectedobjectitemreceiptnumber === 0) {
			if (receipt.receiptnumber != null && receipt.receiptnumber > 0) {
				dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.RECEIPT_IS_OPEN))));
			} else {
				if (objectItems.length > 1) {
					//Merge objects, therefore open receipt immediately
					dispatch(receiptAction.getReceiptByObjectItems(selectedobjectitemid, objectItems));
					if (getState().layoutState.groups !== null && getState().layoutState.groups.items.length > 0) {
						dispatch(layoutAction.setGroup(getState().layoutState.groups.items[0].KeyLayoutGroupId))
					}
					hashHistory.push('/overview');
				} else {
					dispatch(receiptAction.setObjectItem(selectedobjectitemid));
				}
			}
		} else {
			await dispatch(getObjectGroupList(posid));
			const refreshedObjectItem = dispatch(dataActions.getObjectItem(selectedobjectitemid));
			if(refreshedObjectItem){
				if (refreshedObjectItem.Locked && !dispatch(hasRight(right.POS_UNBLOCK)) && !dispatch(dataActions.getLoggedInId(refreshedObjectItem.LockedByUser))) {
					dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.OBJECT_OPEN_BY_CASHREGISTER)).format(refreshedObjectItem.ItemNumber)));
					return;
				}
			}
			dispatch(generalActions.loadingStart());
			dispatch(receiptAction.getReceiptByObjectItem(selectedobjectitemid)).then(() => {
				dispatch(generalActions.loadingEnd());
			});

			if (getState().layoutState.groups !== null && getState().layoutState.groups.items.length > 0) {
				dispatch(layoutAction.setGroup(getState().layoutState.groups.items[0].KeyLayoutGroupId))
			}

			//Production pos
			if (getState().generalState.posType === types.POSTYPE_PRODUCTIONKIOSK) {
				hashHistory.push('/production');
			}
			else {
				hashHistory.push('/overview');
			}
		}

		dispatch(generalActions.setKeyFunctionExecuted(null));
	}
}

function processObjectManagementClose() {
	return (dispatch, getState) => {
		var state = getState();
		var receiptNumber = state.receiptState.receipt.receiptnumber;
		if (state.receiptState.receipt.objectitemid <= 0) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.OPEN_OBJECT))))
		} else {
			if (receiptNumber) {
				if (state.receiptState.receipt.objectitemid || (state.objectManagementState.selectedobjectitem && state.objectManagementState.selectedobjectitem.id)) {
					dispatch(receiptAction.closeReceipt(false, false));
				}
			} else if (state.receiptState.receipt.receiptnumber > 0) {
				dispatch(receiptAction.cancelReceipt());
			} else {
				dispatch(receiptAction.clearObjectItem(state.receiptState.receipt.objectitemid));
			}
		}
	}
}

function processObjectManagementProcess() {
	return (dispatch, getState) => {
		if (getState().receiptState.receipt.objectitemid <= 0) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.OPEN_OBJECT))))
		} else {
			dispatch(receiptAction.processObject(dispatch, getState));
		}
	}
}

export function processObjectTransfer() {
	return (dispatch, getState) => {
		const receiptNumber = getState().receiptState.receipt.receiptnumber
		const posid = getState().generalState.posId
		if (receiptNumber != null && receiptNumber >= 0) {
			dispatch(generalActions.loadingStart());
			dispatch(getObjectGroupList(posid)).then(() => {
				const objectGroups = getState().objectManagementState.objectgroups;
				if (objectGroups.length > 0) {
					dispatch(setCurrentObjectGroup(objectGroups[0].ObjectGroupId));
				}
				dispatch(setMessageBarText(dispatch(dataActions.getTranslation(resource.CHOOSE_OBJECT_FOR_MERGE))));
				dispatch(generalActions.loadingEnd());

				hashHistory.push('/objectmanagement');
			});
		}
		else {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_RECEIPT_OPEN))))
		}
	}
}

function continueObjectManagementTransfer() {
	return (dispatch, getState) => {
		if (getState().objectManagementState.selectedobjectitem.receiptnumber > 0) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.TABLE_IN_USE))));
			return;
		}
		const selectedobjectitem = getState().objectManagementState.selectedobjectitem;
		dispatch(receiptAction.transferReceipt(selectedobjectitem.id))
		dispatch(generalActions.setKeyFunctionExecuted(null));
		hashHistory.push('/overview');
	}
}

function processPrintNota(param) {
	var paramsObj = JSON.parse(param);
	var templateId = paramsObj && (parseInt(paramsObj.SetTemplate, 10) || 0);
	return dispatch => {
		dispatch(receiptAction.printNota(templateId));
	}
}

function processFastPayment(param) {
	return dispatch => {
		dispatch(receiptAction.fastPayment(param));
	}
}

function splitReceiptConfirm(receiptleft, receiptright) {
	return (dispatch) => {
		hashHistory.push('/objectmanagement');
		return (dispatch, getState) => {
			dispatch(generalActions.loadingStart());
			const posid = getState().generalState.posId;
			dispatch(getObjectGroupList(posid)).then(() => {
				const objectGroups = getState().objectManagementState.objectgroups;
				if (objectGroups.length > 0) {
					dispatch(setCurrentObjectGroup(objectGroups[0].ObjectGroupId));
				}
				dispatch(setMessageBarText(dispatch(dataActions.getTranslation(resource.CHOOSE_OBJECT_TO_SPLIT))));
				dispatch(generalActions.loadingEnd());

				hashHistory.push('/objectmanagement');
			});
		}
	}
}

function processSplitReceipt() {
	return (dispatch, getState) => {
		let containsDiscount = false;
		getState().receiptState.receipt.lines.map(l => {
			if (l.linetype === types.DISCOUNT_LINE) {
				containsDiscount = true;
			}
			if (l.discount.length > 0) {
				containsDiscount = true;
			}

			return '';
		});

		let msg = '';
		if (getState().receiptState.receipt.objectitemid <= 0) {
			msg = dispatch(dataActions.getTranslation(resource.SELECT_OBJECT));
		} else if (getState().receiptState.receipt.iscreated) {
			msg = 'Tafel nog niet opgeslagen';
		} else if (containsDiscount) {
			msg = 'Tafel splitsen niet mogelijk door korting';
		}

		if (msg !== '') {
			dispatch(generalActions.setMessageModal(true, msg));
		}
		else {
			const receiptlines_left = Object.assign([], getState().receiptState.receipt.lines);
			const receiptlines_right = [];
			dispatch(modalAction.setSplitReceiptModal(true, receiptlines_left, receiptlines_right, splitReceiptConfirm, dispatch(dataActions.getTranslation(resource.SPLIT))));
		}
	}
}

function continueSplitReceipt() {
	return (dispatch, getState) => {
		if (getState().objectManagementState.selectedobjectitem.receiptnumber > 0) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.TABLE_IN_USE))));
			return;
		}

		const leftreceiptlines = receiptFunction.createReceiptLines(getState().modalState.splitReceiptModal.receiptlinesleft);
		const rightreceiptlines = receiptFunction.createReceiptLines(getState().modalState.splitReceiptModal.receiptlinesright);

		const receiptleft = dispatch(receiptFunction.createReceipt(leftreceiptlines, getState().receiptState.receipt.objectitemid, getState().receiptState.receipt.receiptnumber, getState().receiptState.receipt.objectitemname));
		const receiptright = dispatch(receiptFunction.createReceipt(rightreceiptlines, getState().objectManagementState.selectedobjectitem.id, -1));

		dispatch(generalActions.loadingStart());
		dispatch(receiptAction.splitReceipt(receiptleft, receiptright));
		dispatch(generalActions.setKeyFunctionExecuted(null));

		hashHistory.push('/overview');
	}
}

export function processPartialPaymentAmountConfirm(amount, counter, total) {
	return dispatch => {
		dispatch(receiptAction.addPaymentLineWithAmount(amount));
		if (counter <= total) {
			dispatch(generalActions.setConfirmModal(dispatch(dataActions.getTranslation(resource.PARTIAL_PAYMENT_AMOUNT)).format(amount.toFixed(2), counter, total)
				, processPartialPaymentAmountConfirm
				, null
				, [amount, counter + 1, total]
				, null));
		}
	}
}

function processPartialPaymentAmount() {
	return (dispatch, getState) => {
		const inputquantitynegative = getState().receiptState.input.inputquantitynegative;
		let quantity = parseInt(getState().receiptState.input.inputquantity, 10)
		if (inputquantitynegative) {
			quantity *= -1;
		}

		if (quantity <= 0) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ENTER_VALID_QUANTITY_TO_DIVIDE_RECEIPTAMOUNT))));
			return;
		}

		if (!getState().receiptState.receipt.receiptnumber) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_RECEIPT_OPEN))));
			return;
		}

		let amount = 0;
		getState().receiptState.receipt.lines.map(rec => {
			amount += rec.price;
			return '';
		});

		if (amount === 0) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_AMOUNT_TO_PAY))));
			return;
		}

		amount /= quantity;

		dispatch(generalActions.setConfirmModal(dispatch(dataActions.getTranslation(resource.PARTIAL_PAYMENT_AMOUNT)).format(amount.toFixed(2), 1, quantity)
			, processPartialPaymentAmountConfirm
			, null
			, [amount, 2, quantity]
			, null));
	}
}

function processPartialPaymentArticle() {
	return (dispatch, getState) => {
		const receiptlines_left = [];
		getState().receiptState.receipt.lines.map(line => {
			const copyLine = Object.assign({}, line);
			if (copyLine.quantitypaid > 0) {
				const singleprice = copyLine.price / copyLine.quantity;
				copyLine.quantity -= copyLine.quantitypaid;
				copyLine.price = copyLine.quantity * singleprice;
			}
			if (copyLine.linetype !== types.PAYMENT_LINE && copyLine.quantity !== 0) {
				receiptlines_left.push(copyLine);
			}
			return '';
		});

		const receiptlines_right = [];
		if (receiptlines_left.length > 0) {
			dispatch(modalAction.setSplitReceiptModal(
				true,
				receiptlines_left,
				receiptlines_right,
				partialPaymentArticleConfirm,
				dispatch(dataActions.getTranslation(resource.CHECKOUT))
			));
		} else {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_ARTICLES_ENTERED))));
		}
	}
}

export function partialPaymentArticleConfirm(receiptleft, receiptright) {
	return (dispatch, getState) => {
		let paymentAmount = 0;
		let updatedReceiptLines = []

		receiptright.map(rightline => {
			paymentAmount += rightline.price;
			return '';
		});

		if (receiptright.length > 0) {
			dispatch(receiptAction.addPaymentLineWithAmount(paymentAmount));
			getState().receiptState.receipt.lines.map(receiptline => {
				const copyLine = Object.assign({}, receiptline);
				receiptright.map(rightline => {
					if (copyLine.id === rightline.id) {
						copyLine.quantitypaid += rightline.quantity;
					}
					return '';
				});
				updatedReceiptLines.push(copyLine);
				return '';
			});

			dispatch(receiptAction.updateReceiptLines(updatedReceiptLines));
		}

		dispatch(modalAction.setSplitReceiptModal(false, [], [], null));
	}
}

export function setItemNameConfirm(itemName) {
	return dispatch => {
		dispatch(receiptAction.setReceiptObjectItemName(itemName));
	}
}
function processObjectManagementSetItemName() {
	return (dispatch, getState) => {
		if (getState().receiptState.receipt.objectitemid <= 0) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.SELECT_OBJECT))));
		} else {
			dispatch(layoutActions.toggleKeyboard(true, null, dispatch(dataActions.getTranslation(resource.OBJECT_NAME)), setItemNameConfirm, [], true));
		}
	}
}

export function processSubtotal() {
	return (dispatch, getState) => {
		dispatch(receiptAction.updateReceiptLines(receiptFunction.AddSubtotal(dispatch, getState)));
	}
}

function processDiscount(isAmount, param) {
	return (dispatch, getState) => {
		let receiptContainsDiscount = false;
		let receiptAmount = 0;
		let line = receiptFunction.getSelectedLine(getState);
		let isLineForDiscount = false;

		let lastLine = null;
		getState().receiptState.receipt.lines.map(l => {
			if (l.linetype !== types.DISCOUNT_LINE) {
				lastLine = l;
			} else {
				receiptContainsDiscount = true;
			}
			
			if (l.linetype === types.ARTICLE_LINE) {
				const article = dispatch(dataActions.getArticle(l.itemid));
				if (article !== null
					&& !article.BlockDiscount) {
					isLineForDiscount = true;
				}
			}

			if (l.linetype !== types.SUBTOTAL_LINE) {
				receiptAmount += l.price;
				l.discount.map(d => {
					receiptAmount += d.Price;
					return '';
				});
			}
			return '';
		});

		if (line === null) {
			line = lastLine;
		}

		//Check if line has value and is of type Article or Subtotal
		if (line == null ||
			(line !== null && line.linetype !== types.ARTICLE_LINE && line.linetype !== types.SUBTOTAL_LINE)) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_VALID_RECEIPTLINE_SELECTED))));
			return;
		}

		//Block discount on article
		if (line.linetype === types.ARTICLE_LINE) {
			const article = dispatch(dataActions.getArticle(line.itemid));
			if (article !== null
				&& article.BlockDiscount) {
				dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.DISCOUNT_NOT_POSSIBLE))));
				return;
			}
		}

		let discountAmount = 0;
		var discountParam = $.parseJSON(param);
		if (discountParam
			&& discountParam.DiscountAmount) {
			if (parseFloat(discountParam.DiscountAmount) > 0) {
				discountAmount = parseFloat(discountParam.DiscountAmount);
			}
		}


		if (discountAmount === 0) {
			if (getState().receiptState.input.inputquantity !== '0') {
				discountAmount = getState().receiptState.input.inputquantity;
			}
		}

		//Check if a value is entered
		if (discountAmount <= 0) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_QUANTITY))));
			return;
		}

		//Check if line has already discount
		if ((line.linetype === types.SUBTOTAL_LINE && receiptContainsDiscount)
			|| (line.linetype === types.ARTICLE_LINE && line.discount.length > 0)) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.DISCOUNT_ALREADY_EXISTS))));
			return;
		}

		//Check if there is line for discount
		if (!isLineForDiscount) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.DISCOUNT_NOT_POSSIBLE))));
			return;
		}

		//Check if percentage is not bigger then 100
		if (!isAmount && discountAmount > 100) {
			dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.PERCENTAGE_TO_HIGH))));
			return;
		}

		//Check if amount is not bigger then line / receipt
		if (isAmount) {
			if ((line.linetype === types.ARTICLE_LINE && line.price < discountAmount)
				|| (line.linetype === types.SUBTOTAL_LINE && receiptAmount < discountAmount)) {
				dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.AMOUNT_TO_HIGH))));
				return;
			}
		}

		if (discountParam && discountParam.SetSurcharge) {
			discountAmount *= -1;
		}
		let discountDescription = (discountParam && discountParam.Description.length > 0) ?  discountParam.Description: "";

		if (isAmount) {
			let discountParam = { amount : discountAmount, discountDescription};
			dispatch(receiptAction.updateReceiptLines(receiptFunction.AddDiscountAmount(dispatch, getState, discountParam, line)));
		} else {
			let discountParam = { percentage : discountAmount, discountDescription};
			dispatch(receiptAction.updateReceiptLines(receiptFunction.AddDiscountPercentage(dispatch, getState, discountParam, line)));
		}

		dispatch(receiptAction.resetInputQuantity());
	}
}

export function processDiscountMenu() {
	return (dispatch) => {
		dispatch(receiptAction.handleDiscountMenu());
	}
}

export function resetFiscalPrinter() {
	return (dispatch, getState) => {
		dispatch(generalActions.resetFiscalPrinter());
	}
}

function processPriceList(param) {
	return (dispatch, getState) => {

		var listParm = $.parseJSON(param);
		var currentPriceListId = getState().receiptState.receipt.pricelistid;


		if (listParm && listParm.SetPriceList) {
			var listId = parseInt(listParm.SetPriceList, 10);
			dispatch(continuePriceList(compareListId(currentPriceListId, listId)));
			return;
		}

		if (getState().generalState.pricelists.length === 1) {
			var newListId = getState().generalState.pricelists[0].PriceListId;
			dispatch(continuePriceList(compareListId(currentPriceListId, newListId)));
			return;
		}


		var items = [{ ItemId: 0, Description: dispatch(dataActions.getTranslation(resource.NONE)) }];

		getState().generalState.pricelists.map(pl => {
			items.push({
				Description: pl.Description,
				ItemId: pl.PriceListId
			});
			return '';
		});

		dispatch(generalActions.setSelectModal(items, true, dispatch(dataActions.getTranslation(resource.SELECT_PRICELIST)), continuePriceList));
	}
}

function compareListId(currentId, newId) {
	var num = 0;

	if (currentId !== newId)
		num = newId;

	return num;
}

export function continuePriceList(itemId) {
	return (dispatch, getState) => {
		dispatch(receiptAction.setPriceList(itemId));
		dispatch(receiptAction.updateReceiptLines(getState().receiptState.receipt.lines));
	}
}

function processManagerLogin(param) {
	return dispatch => {
		dispatch(receiptAction.showManagerLogin(param));
	}
}

function reprintReceipt() {
	return (dispatch, getState) => {
		if (!(getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox) && !getState().generalState.hasFiscalPrinter) {
			const id = getState().generalState.previousReceiptId;

			if (id > -1) {
				const devices = getState().generalState.devices;
				devices.map(d => {
					if (d.printertype === 100) {
						dispatch(receiptAction.reprintReceipt(id, d.deviceid, d.posdevicelinkid));
						return '';
					}
					return '';
				})
			}
		}
	}
}

function processShowOrders(param) {
	return dispatch => {
		dispatch(receiptAction.showOrders(param));
	}
}

export function processSelectPager(param) {
	return dispatch => {
		dispatch(receiptAction.selectPager(param));
	}
}

function processKeyLayoutGroup(param) {
	return dispatch => {
		var setKeyLayoutGroup = $.parseJSON(param);
		var groupId = -1;

		if (setKeyLayoutGroup && setKeyLayoutGroup.SetKeyLayoutGroup) {
			groupId = parseInt(setKeyLayoutGroup.SetKeyLayoutGroup, 10);
		}

		dispatch(layoutAction.setGroup(groupId));
	}
}

function processSetInvoice() {
	return dispatch => {
		dispatch(invoiceAction.toggleInvoicingOnOff());
	}
}

function processSetInvoiceReference() {
	return dispatch => {
		dispatch(invoiceAction.setInvoiceReference());
	}
}
		
function processPrintInvoice() {
	return dispatch => {
		dispatch(invoiceAction.printInvoice());
	}
}

function processReservation(keyFunctionParam) {
	return dispatch => {
		dispatch(modalAction.setReservationModal(true, null, keyFunctionParam));
	}
}

function addBalanceToTicket(param) {
	return dispatch => {
		var paramObj = JSON.parse(param);
		dispatch(modalAction.showAddBalanceToTicketModal(paramObj.SetPayment, paramObj.SetPaymentAmount));
	}
}

function processCashIn(){
	return dispatch => dispatch(modalAction.setCashRegistrationModal(
		true,
		true,
		dispatch(dataActions.getTranslation(resource.CASH_IN)),
		''
	));
}

function processCashOut(){
	return dispatch => dispatch(modalAction.setCashRegistrationModal(
		true,
		false,
		dispatch(dataActions.getTranslation(resource.CASH_OUT)),
		''
	));
}

function processParkOrder(param) {
	return dispatch => dispatch(receiptAction.parkOrder(param));
}


// WEBPACK FOOTER //
// src/actions/keyFunctionActions.js